// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"163":"48fe3a42","578":"059fbb7f","708":"059fbb7f","827":"48fe3a42","930":"059fbb7f","940":"5ac1cb9c","994":"5ac1cb9c"}[chunkId] + ".chunk.css";
};